export function RPC_STATE(state) {
    return {
        ...state,
        meeting: {}
    };
}